import APIConstant from 'constants/ApiConstant';
import { MYM_WEB } from 'constants/RequestUrlConstant';
import { makeAutoObservable, runInAction } from 'mobx';
import { getRequest } from 'utils/apiUtils';
import { getValidDataFromResponse, isValidArray } from 'utils/utilities';

class EducationStore {
	educationList = [];
	educationData = [];
	allEducationData = []; // Store unfiltered data
	statusFilter = null; // Store current status filter

	constructor({ reportsStore }) {
		makeAutoObservable(this);
		this.reportsStore = reportsStore;
	}

	getEducationList = async () => {
		try {
			this.updateGlobalLoadingState();

			const { response } = await getRequest({ url: `${APIConstant.GET_EDUCATION_LIST}/2`, rbu: MYM_WEB });

			const { result, error } = getValidDataFromResponse({ response, isRequired: false });

			if (!error && isValidArray(result)) {
				runInAction(() => {
					this.educationList = result;
				});
			}

			runInAction(() => {
				this.updateGlobalLoadingState();
			});
		} catch (error) {
			console.log('error :>> ', error);
			this.updateGlobalLoadingState();
		}
	};

	handleEducationChange = async (id, title) => {
		console.log("🚀 ~ EducationStore ~ handleEducationChange= ~ id:", id)
		this.updateGlobalLoadingState();
		try {
			if (id) {

				const { response } = await getRequest({ url: `${APIConstant.GET_TOOLBOX_DETAILS}?toolbox_id=${id}&title=${title}`, rbu: MYM_WEB });

				const { result, error } = getValidDataFromResponse({ response });

				if (!error && isValidArray(result)) {
					runInAction(() => {
						this.allEducationData = result; // Store unfiltered data
						this.applyStatusFilter(); // Apply current filter
					});
				}

				runInAction(() => {
					this.updateGlobalLoadingState();
				});
			} else {
				runInAction(() => {
					this.educationData = [];
					this.allEducationData = [];
				});
				this.updateGlobalLoadingState();
			}
		} catch (error) {
			console.log('error :>> ', error);
			this.updateGlobalLoadingState();
		}
	};

	handleStatusFilter = (value) => {
		runInAction(() => {
			this.statusFilter = value;
			this.applyStatusFilter();
		});
	};

	applyStatusFilter = () => {
		runInAction(() => {
			if (!this.statusFilter) {
				// No filter, show all data
				this.educationData = this.allEducationData;
			} else {
				// Filter based on status
				const filterValue = this.statusFilter === 'yes';
				this.educationData = this.allEducationData.filter(item => item.status === filterValue);
			}
		});
	};

	updateGlobalLoadingState = () => {
		this.reportsStore.updateReportsLoadingState();
	};
}

export default EducationStore;
